var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConcorrencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.856,
    height: 15.511,
    viewBox: "0 0 15.856 15.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "concorrencia",
    transform: "translate(-4.24 -5.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    "data-name": "Caminho 1535",
    d: "M125.483,15.638l-.235,3.927a1.359,1.359,0,0,0,.563,1.191,1.328,1.328,0,0,0,1.277.157l3.571-1.433,3.572,1.436a1.328,1.328,0,0,0,1.277-.156,1.359,1.359,0,0,0,.563-1.191l-.233-3.928,2.447-3.033a1.367,1.367,0,0,0,.235-1.29,1.347,1.347,0,0,0-.937-.888l-3.718-.982L131.8,6.136a1.337,1.337,0,0,0-2.275,0l-2.066,3.31-3.717.983a1.347,1.347,0,0,0-.937.889,1.367,1.367,0,0,0,.235,1.29Zm-1.551-3.95a.157.157,0,0,1,.11-.109l3.945-1.043a.6.6,0,0,0,.353-.26l2.191-3.51a.148.148,0,0,1,.257,0l2.191,3.511a.6.6,0,0,0,.353.26l3.946,1.042a.157.157,0,0,1,.11.109.178.178,0,0,1-.03.172l-2.592,3.212a.6.6,0,0,0-.132.375c0,.012,0,.024,0,.035l.247,4.156a.171.171,0,0,1-.071.155.137.137,0,0,1-.138.017l-3.794-1.525a.6.6,0,0,0-.444,0l-3.793,1.522a.137.137,0,0,1-.138-.018.171.171,0,0,1-.071-.155l.249-4.157a.6.6,0,0,0-.131-.409l-2.591-3.21a.179.179,0,0,1-.03-.172Z",
    transform: "translate(-118.492 0)",
    fill: "#7d0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcorrencia);
export default __webpack_public_path__ + "static/media/concorrencia.4cce5b0c80038f6cd24ed006c3048895.svg";
export { ForwardRef as ReactComponent };